<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
                <li>{{ pageTitle.subTitle }}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">
                    <div
                        *ngIf="this.pageData === 'what-is-CoP'"
                        class="article-image"
                    >
                        <img src="assets/img/gallery/img1.jpg" alt="image" />
                    </div>
                    <div
                        *ngIf="this.pageData === 'CoP-Newsletter3'"
                        class="article-image"
                    >
                        <img
                            src="assets/img/blog/Newsletter3.png"
                            alt="image"
                        />
                    </div>
                    <div
                        *ngIf="this.pageData === 'CoP-Roles'"
                        class="article-image"
                    >
                        <img src="assets/img/gallery/img8.jpg" alt="image" />
                    </div>
                    <div
                        *ngIf="this.pageData === 'benefits-CoP'"
                        class="article-image"
                    >
                        <img src="assets/img/gallery/img3.jpg" alt="image" />
                    </div>
                    <div
                        *ngIf="this.pageData === 'UDF-CoP'"
                        class="article-image"
                    >
                        <img
                            src="assets/img/blog/UDF-CoP-Banner.png"
                            alt="image"
                        />
                    </div>
                    <div
                        *ngIf="this.pageData === 'CoP-Newsletter1'"
                        class="article-image"
                    >
                        <img
                            src="assets/img/blog/Newsletter1.png"
                            alt="image"
                        />
                    </div>
                    <div
                        *ngIf="this.pageData === 'CoP-Newsletter2'"
                        class="article-image"
                    >
                        <img src="assets/img/blog/Newletter2.png" alt="image" />
                    </div>
                    <div class="article-content">
                        <!-- <div class="entry-meta">
                            <ul>
                                <li>
                                    <i class='bx bx-folder-open'></i>
                                    <span>Category</span>
                                    <a href="#">Fashion</a>
                                </li>
                                <li>
                                    <i class='bx bx-group'></i>
                                    <span>View</span>
                                    <a href="#">813,454</a>
                                </li>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span>Last Updated</span>
                                    <a href="#">25/04/2020</a>
                                </li>
                            </ul>
                        </div> -->

                        <h2 *ngIf="this.pageData === 'what-is-CoP'">
                            What is Community of Practice?
                        </h2>
                        <h2 *ngIf="this.pageData === 'benefits-CoP'">
                            Benefits of Communities of Practice
                        </h2>
                        <h2 *ngIf="this.pageData === 'CoP-Roles'">
                            Community of Practice Roles and Responsibilities
                        </h2>
                        <h2 *ngIf="this.pageData === 'UDF-CoP'">
                            Upstream Data Foundation - CoP
                        </h2>
                        <p *ngIf="this.pageData === 'what-is-CoP'">
                            In 1991, cognitive anthropologists
                            <a
                                href="https://www.amazon.com/Communities-Practice-Cognitive-Computational-Perspectives/dp/0521663636/ref=asc_df_0521663636/?tag=hyprod-20&linkCode=df0&hvadid=312089933244&hvpos=&hvnetw=g&hvrand=6127733206139946479&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9060439&hvtargid=pla-521029305517&psc=1"
                                >Jean Lave and Etienne Wenger</a
                            >
                            first coined the term "community of practice" while
                            studying group learning. They defined it as "a group
                            of people who share an interest, a craft, and/or a
                            profession." Communities of practice have been
                            around since the beginning of civilization. Groups
                            of people have come together telling stories,
                            imparting wisdom, and passing on tradition. Any
                            group of people can form a CoP—a group of developers
                            exploring a new product or tool, for example, or
                            data analysts discussing best practices for data
                            visualization.
                        </p>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            Fostering and supporting communities of practice
                            (CoPs) can be a great strategy for building a more
                            open organization. Members of communities of
                            practice interact regularly, discuss various topics,
                            and solve problems collectively and collaboratively.
                            These communities provide members with an
                            opportunity to share their expertise, learn from
                            others, and network with one another.
                        </p>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            As Luis Gonçalves states in
                            <a
                                href="https://opensource.com/open-organization/resources/open-org-definition"
                                >Learning Organisation</a
                            >:
                        </p>
                        <p *ngIf="this.pageData === 'CoP-Roles'">
                            There are three main roles required for a Community
                            of Practice (CoP) to be successful. The roles,
                            responsibilities, and time commitment are outlined
                            below.
                        </p>
                        <blockquote
                            *ngIf="
                                this.pageData != 'CoP-Roles' &&
                                this.pageData != 'UDF-CoP' &&
                                this.pageData != 'CoP-Newsletter3'
                            "
                            class="wp-block-quote"
                        >
                            <p *ngIf="this.pageData === 'what-is-CoP'">
                                Not all groups are communities of practice.
                            </p>
                            <!-- <cite>Tom Cruise</cite> -->
                            <p *ngIf="this.pageData === 'benefits-CoP'">
                                CoPs provide a shared context where members of
                                the organisation can communicate and share
                                information; stimulate learning through
                                peer-to-peer mentoring, coaching,
                                self-reflection, and collaboration; generate new
                                knowledge; and initiate projects that develop
                                tangible results.
                            </p>
                            <cite *ngIf="this.pageData === 'benefits-CoP'"
                                >Luis Gonçalves</cite
                            >
                        </blockquote>

                        <p *ngIf="this.pageData === 'what-is-CoP'">
                            A CoP must have a shared domain of interest,
                            practitioners who share resources (tools,
                            techniques, and ideas), and community members. A CoP
                            forms at the intersection of those factors.
                        </p>
                        <p *ngIf="this.pageData === 'UDF-CoP'">
                            The Upstream Data Foundation Community of Practice
                            welcomes anyone interested in learning more about
                            data ingestions, data platforms, data literacy and
                            data-driven decision making while creating an
                            environment of collaboration and connection.
                        </p>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            But those aren't the only value such communities can
                            offer. Communities of practice can also enhance an
                            organization in the following ways (summarized in
                            Figure 1).
                        </p>
                        <ul
                            *ngIf="this.pageData === 'what-is-CoP'"
                            class="wp-block-gallery columns-3"
                        >
                            <li class="blocks-gallery-item">
                                <figure>
                                    <img
                                        src="assets/img/blog/domain.png"
                                        alt="image"
                                    />
                                </figure>
                                <div style="margin-top: 30px">
                                    <h5
                                        style="
                                            text-align: center;
                                            margin-bottom: 20px;
                                        "
                                    >
                                        Domain
                                    </h5>
                                    <p>
                                        A community of practice is defined by a
                                        shared domain of interest. It's not
                                        merely a group of friends hanging out
                                        together; members have a commitment to
                                        the success of the domain and a desire
                                        to share their knowledge. They value use
                                        cases, success stories, feedback, and
                                        learning from the other members.
                                    </p>
                                </div>
                            </li>

                            <li class="blocks-gallery-item">
                                <figure>
                                    <img
                                        src="assets/img/blog/practice.png"
                                        alt="image"
                                    />
                                </figure>
                                <div style="margin-top: 30px">
                                    <h5
                                        style="
                                            text-align: center;
                                            margin-bottom: 20px;
                                        "
                                    >
                                        Practice
                                    </h5>
                                    <p>
                                        A community of practice is not simply a
                                        group of people who like the same
                                        things. Members of CoPs are
                                        practitioners who engage in shared
                                        activities, share resources, tools,
                                        techniques, and ideas. Together they
                                        develop ways of addressing problems in
                                        new ways. Members value interactions and
                                        seek knowledge from each other.
                                    </p>
                                </div>
                            </li>

                            <li class="blocks-gallery-item">
                                <figure>
                                    <img
                                        src="assets/img/blog/members.png"
                                        alt="image"
                                    />
                                </figure>
                                <div style="margin-top: 30px">
                                    <h5
                                        style="
                                            text-align: center;
                                            margin-bottom: 20px;
                                        "
                                    >
                                        Members
                                    </h5>
                                    <p>
                                        Community of practice members engage in
                                        joint activities and discussions, assist
                                        each other, and share their knowledge.
                                        They build relationships that enable
                                        them to learn from each other; they care
                                        about their standing with each other.
                                        Members of a community of practice
                                        participate regularly but do not
                                        necessarily work together on a daily
                                        basis.
                                    </p>
                                </div>
                            </li>
                        </ul>

                        <h3 *ngIf="this.pageData === 'benefits-CoP'">
                            Decreased learning curves
                        </h3>
                        <h3 *ngIf="this.pageData === 'UDF-CoP'">
                            UDF CoP Mission
                        </h3>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            Many organizations face the challenge of rapidly
                            increasing productivity of new employees (or
                            members). This task becomes especially challenging
                            in organizations where an employee's manager may be
                            located in a different state, country, or region.
                            Communities of practice offer new employees a
                            network of connections they can tap into more
                            quickly and easily. By joining a CoP, they can
                            immediately access a network of experts and share
                            resources, ask questions, and seek guidance outside
                            the formal lines of the organizational chart.
                        </p>
                        <h2 *ngIf="this.pageData === 'CoP-Roles'">
                            Community of Practice Champion
                        </h2>
                        <h4 *ngIf="this.pageData === 'CoP-Roles'">
                            Responsibilities
                        </h4>
                        <ul *ngIf="this.pageData === 'CoP-Roles'">
                            <li>
                                Responsible for setting goals of the CoP
                                (independent of solutions)
                                <ul class="features-list">
                                    <li>
                                        <i class="bx bx-badge-check"></i>Decide
                                        the strategy of the CoP based on
                                        business and community needs
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Keep
                                        CoP focused to its objectives
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Manage
                                        and maintain CoP requirement
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Act as
                                        a collaboration champion for the CoP
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Day-day community management/operations
                                <ul class="features-list">
                                    <li>
                                        <i class="bx bx-badge-check"></i>Conduct
                                        periodic CoP meetings - recommended
                                        monthly or quarterly.
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i
                                        >Administrate the CoP content, making
                                        sure that latest news, latest content,
                                        learning opportunities, and events are
                                        updated as needed
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i
                                        >Categorize and validate submitted
                                        content (with assistance of the core
                                        team members).
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i
                                        >Moderate day-to-day issues, questions,
                                        and requests.
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Onboard
                                        new members and engage them in
                                        community-related tasks.
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Plan
                                        and schedule of community activities and
                                        initiatives.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Communications and Change Management:
                                <ul class="features-list">
                                    <li>
                                        <i class="bx bx-badge-check"></i>Bring
                                        in new ideas when the community starts
                                        to lose energy
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i
                                        >Evangelize the CoP and recruit new
                                        community members.
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Act as
                                        a liaison with other communities
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i
                                        >Recognize and reward contributions
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <h4 *ngIf="this.pageData === 'CoP-Roles'">
                            Benefits of being a Community Champion
                        </h4>
                        <ul
                            *ngIf="this.pageData === 'CoP-Roles'"
                            class="features-list"
                        >
                            <li>
                                <i class="bx bx-badge-check"></i> Gain
                                experience with community leadership and
                                management.
                            </li>
                            <li>
                                <i class="bx bx-badge-check"></i> Global
                                exposure in the organization resulting in
                                expanded visibility/networking.
                            </li>
                            <li>
                                <i class="bx bx-badge-check"></i> The
                                opportunity to own and grow an idea from
                                inception to fruitition.
                            </li>
                            <li>
                                <i class="bx bx-badge-check"></i> Recognized as
                                a key players and subject matter experts in your
                                area of "practice"
                            </li>
                        </ul>
                        <h4 *ngIf="this.pageData === 'CoP-Roles'">
                            Time requirement
                        </h4>
                        <ul
                            *ngIf="this.pageData === 'CoP-Roles'"
                            class="features-list"
                        >
                            <li>
                                <i class="bx bx-badge-check"></i> Approximately
                                4-8 hours/month. Initially this time may be 6-10
                                hours/month (until the CoP is set up and
                                functioning).
                            </li>
                        </ul>

                        <h2 *ngIf="this.pageData === 'CoP-Roles'">
                            Community of Practice Core Team member
                        </h2>
                        <h4 *ngIf="this.pageData === 'CoP-Roles'">
                            Responsibilities
                        </h4>
                        <ul *ngIf="this.pageData === 'CoP-Roles'">
                            <li>
                                Managing community collateral and best
                                practices:
                                <ul class="features-list">
                                    <li>
                                        <i class="bx bx-badge-check"></i>Review
                                        community collateral submissions for
                                        consistency, quality, and content value.
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Look
                                        outside the community to identify
                                        relevant information and refine it for
                                        the CoP.
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i>Present
                                        new information to the community
                                        members.
                                    </li>
                                    <li>
                                        <i class="bx bx-badge-check"></i
                                        >Participate in virtual and face-to-face
                                        knowledge sharing.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Communications:
                                <ul class="features-list">
                                    <li>
                                        <i class="bx bx-badge-check"></i
                                        >Evangelize and bolster community
                                        membership.
                                    </li>
                                </ul>
                            </li>
                            <li>Attend CoP team meetings.</li>
                            <li>Assist the CoP Champion as needed.</li>
                        </ul>
                        <h4 *ngIf="this.pageData === 'CoP-Roles'">
                            Benefits of being a CoP Core Team member
                        </h4>
                        <ul
                            *ngIf="this.pageData === 'CoP-Roles'"
                            class="features-list"
                        >
                            <li>
                                <i class="bx bx-badge-check"></i> Continuous
                                learning as a result of participation
                            </li>
                            <li>
                                <i class="bx bx-badge-check"></i> Networking
                                with the global audience and team members
                            </li>
                            <li>
                                <i class="bx bx-badge-check"></i> Gaining
                                project management skills by leading smaller
                                projects/initiatives
                            </li>
                            <li>
                                <i class="bx bx-badge-check"></i> Develop
                                leadership and community building skills
                            </li>
                            <li>
                                <i class="bx bx-badge-check"></i> The
                                opportunity to own and grow an idea from
                                inception to fruitition.
                            </li>
                        </ul>
                        <h4 *ngIf="this.pageData === 'CoP-Roles'">
                            Time requirement
                        </h4>
                        <ul
                            *ngIf="this.pageData === 'CoP-Roles'"
                            class="features-list"
                        >
                            <li>
                                <i class="bx bx-badge-check"></i> Core Team
                                members should be able to commit to 2-4
                                hours/month, depending on availability.
                            </li>
                        </ul>
                        <h2 *ngIf="this.pageData === 'CoP-Roles'">
                            Community of Practice Member
                        </h2>
                        <ul
                            *ngIf="this.pageData === 'CoP-Roles'"
                            class="features-list"
                        >
                            <li>
                                <i class="bx bx-badge-check"></i> As a member,
                                participation in discussion forums, posting
                                blogs, content, editing content, reaching out to
                                other members, etc. is encouraged.
                            </li>
                        </ul>

                        <h3 *ngIf="this.pageData === 'benefits-CoP'">
                            Increased collaboration
                        </h3>
                        <h3 *ngIf="this.pageData === 'UDF-CoP'">
                            UDF CoP Champions
                        </h3>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            A recent
                            <a
                                href="https://www.mycustomer.com/experience/engagement/the-stats-that-prove-silos-are-your-biggest-cx-challenge"
                                >survey from My Customer.com</a
                            >
                            shows that 40 percent of company employees report
                            not feeling adequately supported by their
                            colleagues—because "different departments have their
                            own agendas." A lack of collaboration between
                            departments limits innovation and increases
                            opportunities for miscommunication. Communities of
                            practice encourage members from all roles across all
                            departments to unite in sharing their expertise.
                            This increases collaboration and reduces the threat
                            of organizational silos.
                        </p>

                        <h3 *ngIf="this.pageData === 'benefits-CoP'">
                            Rapid problem-solving
                        </h3>
                        <h3 *ngIf="this.pageData === 'UDF-CoP'">
                            UDF Meetings
                        </h3>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            Communities of practice provide a centralized
                            location for communication and resources useful for
                            solving organizational or business problems.
                            Enabling people to come together—regardless of their
                            organizational reporting structure, location, and/or
                            management structure—encourages problem-solving and
                            can lead to faster resolution of those problems.
                        </p>
                        <h3 *ngIf="this.pageData === 'benefits-CoP'">
                            Enhanced innovation
                        </h3>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            Researchers
                            <a
                                href="https://www.researchgate.net/profile/Ferry_Koster/publication/313659568_Inter-organizational_cooperation_and_organizational_innovativeness_A_comparative_study/links/59e64d510f7e9b13aca3c224/Inter-organizational-cooperation-and-organizational-innovativeness-A-comparative-study.pdf"
                                >Pouwels and Koster</a
                            >
                            recently argued that "collaboration contributes to
                            innovation." CoPs provide a unique opportunity for
                            members to collaborate on topics within their shared
                            domains of interest and passion. This passion
                            ignites a desire to discover new and innovative ways
                            to solve problems and create new ideas.
                        </p>
                        <p *ngIf="this.pageData === 'benefits-CoP'">
                            <a
                                href="https://en.wikipedia.org/wiki/%C3%89tienne_Wenger"
                                >Étienne Wenger</a
                            >, an educational theorist and proponent of
                            communities of practice, said that learning doesn't
                            only occur through a master; it also happens among
                            apprentices. Communities of practice foster learning
                            by connecting apprentices while encouraging
                            collaboration and offering an opportunity for
                            creative problem-solving and innovation.
                        </p>

                        <h3 *ngIf="this.pageData === 'UDF-CoP'">Contact Us!</h3>

                        <div *ngIf="this.pageData === 'CoP-Newsletter3'">
                            <h3>Upstream Data Foundation (UDF)</h3>
                            <p>Newsletter #3</p>
                            <p>
                                <a
                                    href="https://ishareteam7.na.xom.com/sites/UDAO/Data_Architecture/Library/Presentations/Upstream%20Data%20Foundation%20-%20Vision.pptx"
                                    >We believe easy access to trusted data
                                    enables valuable insights.</a
                                >
                            </p>
                            <p>In this exciting edition:</p>
                            <ul>
                                <li>
                                    <p>
                                        <a
                                            href="https://mail.google.com/mail/u/0/#m_-3814518649449381438_Conceptual_data_model"
                                            >Conceptual Data Model Dashboard is
                                            released</a
                                        >
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <a
                                            href="https://mail.google.com/mail/u/0/#m_-3814518649449381438_OSDU_release"
                                            >Want to see what data is part of
                                            each OSDU release?</a
                                        >
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <a
                                            href="https://mail.google.com/mail/u/0/#m_-3814518649449381438_UDGP_Collaboration"
                                            >UDGP &ndash; Collaborating with our
                                            customers</a
                                        >
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <a
                                            href="https://mail.google.com/mail/u/0/#m_-3814518649449381438_Addition_dashboards_data_Catalog"
                                            >Users may now request addition of
                                            dashboards in Data Catalog</a
                                        >
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <a
                                            href="https://mail.google.com/mail/u/0/#m_-3814518649449381438_Upstream_data_gov_policies"
                                            >Upstream Data Governance Policies
                                            Annual Review &ndash; UDF Assessment
                                            Activity</a
                                        >
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <a
                                            href="https://mail.google.com/mail/u/0/#m_-3814518649449381438_OSDU_PaaS"
                                            >ExxonMobil&rsquo;s OSDU PaaS
                                            solution on the new Microsoft Energy
                                            Data Services</a
                                        >
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <a
                                            href="https://mail.google.com/mail/u/0/#m_-3814518649449381438_Heath"
                                            >Heath Bland elected to the OSDU
                                            Management Committee</a
                                        >
                                    </p>
                                </li>
                            </ul>
                            <div class="news-Article">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <p class="eyebrowText">
                                            Modelling in Action!
                                        </p>
                                        <h3>
                                            Conceptual Data Model Dashboard is
                                            released
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-7 col-md-12">
                                        <p>
                                            A new way to view the Upstream
                                            Conceptual Data Model has been
                                            published! Explore the data entities
                                            and learn more about them and how
                                            they are used.
                                        </p>

                                        <p>
                                            Check it out at:
                                            <a href="http://goto/UCDMdashboard"
                                                >http://goto/UCDMdashboard</a
                                            >
                                        </p>

                                        <div>
                                            Key contact -
                                            <span>Castro, Pamela</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12">
                                        <img
                                            src="assets/img/blog/Newsletter3.png"
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="news-Article">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <p class="eyebrowText">
                                            OSDU Data Releases
                                        </p>
                                        <h3>
                                            Want to see what data is part of
                                            each OSDU release?
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-7 col-md-12">
                                        <p>
                                            A new dashboard has been released
                                            that provides insight into what data
                                            is made available as part of each
                                            OSDU release. This is a great way to
                                            learn more about the data that OSDU
                                            supports.
                                        </p>

                                        <p>
                                            <a href="http://goto/OSDUdashboard">
                                                http://goto/OSDUdashboard</a
                                            >
                                        </p>

                                        <div>
                                            Key contact -
                                            <span>Castro, Pamela</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12">
                                        <img
                                            src="assets/img/blog/Newsletter-Article2.png"
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="news-Article">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <p class="eyebrowText">
                                            UDGP is on your side!
                                        </p>
                                        <h3>
                                            UDGP – Collaborating with our
                                            customers
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-7 col-md-12">
                                        <p>
                                            The UDGP team has been working
                                            directly with Upstream Business
                                            Capability customers to help them to
                                            develop and further their data
                                            governance activities. One recent
                                            result of these collaborative
                                            efforts is the expansion and
                                            refinement of our Upstream Data
                                            Governance Roles and
                                            Responsibilities published
                                            <a
                                                href="https://ishareteam7.na.xom.com/sites/UDAO/Data%20Governance/UDGP%20Essentials/Upstream%20Data%20Governance%20Roles%20-%20final.xlsx"
                                                >here</a
                                            >. We have expanded them to include
                                            roles for both the Capability and
                                            Asset.
                                        </p>

                                        <div>
                                            Key contact -
                                            <span>Anna Paget</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12">
                                        <img
                                            src="assets/img/blog/Newsletter-Article3.png"
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="news-Article">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <p class="eyebrowText">
                                            Got a dashboard? Catalog it!
                                        </p>
                                        <h3>
                                            Users may now request addition of
                                            dashboards in Data Catalog
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-7 col-md-12">
                                        <p>
                                            UDGP has developed a form for users
                                            to fill out and submit to have their
                                            dashboards submitted to the Data
                                            Catalog. We have taken this on as a
                                            service to our customers alleviating
                                            the need to know the Collibra
                                            platform in depth. To submit a
                                            request, complete a simple form
                                            accessed via
                                            <a
                                                href="https://ishareteam7.na.xom.com/sites/UDAO/UDGP/Lists/Dashboards%20to%20Data%20Catalog%20User%20Requests/NewForm.aspx?Source=https%3A%2F%2Fishareteam7%2Ena%2Exom%2Ecom%2Fsites%2FUDAO%2FUDGP%2FLists%2FDashboards%2520to%2520Data%2520Catalog%2520User%2520Requests%2FAllItems%2Easpx&RootFolder="
                                                >goto/CatalogMyDashboard</a
                                            >. Once users submit the completed
                                            request here, their dashboard assets
                                            will be live in DataDash within 72
                                            hours.
                                        </p>

                                        <div>
                                            Key contact -
                                            <span>Amber Schmidt</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12">
                                        <img
                                            src="assets/img/blog/Newsletter-Article4.png"
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="news-Article">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <p class="eyebrowText">
                                            UDGP Annual Policies Review
                                        </p>
                                        <h3>
                                            Upstream Data Governance Policies
                                            Annual Review – UDF Assessment
                                            Activity
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-7 col-md-12">
                                        <p>
                                            In order to support the
                                            Upstream-wide principle of treating
                                            data as an asset, Upstream Data
                                            Governance Program (UDGP) office has
                                            established three policies
                                            (goto/udgppolicies).
                                        </p>
                                        <ul>
                                            <li>
                                                <a
                                                    href="https://wiki.na.xom.com/index.php/Upstream_Data_Governance_Program_Business_Term_Definition_Policy"
                                                    >Upstream Data Governance
                                                    Program Business Term
                                                    Definition Policy</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    href="https://wiki.na.xom.com/index.php/Upstream_Data_Governance_Program_Data_Entity_Source_Policy"
                                                    >Upstream Data Governance
                                                    Program Data Entity Source
                                                    Policy</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    href="https://wiki.na.xom.com/index.php/Upstream_Data_Governance_Program_Reference_Data_Management_Policy"
                                                >
                                                    Upstream Data Governance
                                                    Program Reference Data
                                                    Management Policy</a
                                                >
                                            </li>
                                        </ul>
                                        <p>
                                            To further support alignment of
                                            governance operations, as well as to
                                            set expectations across Upstream
                                            Business Capabilities, UDGP office
                                            has developed an annual review of
                                            these policies.
                                        </p>

                                        <p>
                                            The annual review discussion of
                                            these policies will occur on 5
                                            December and all follow-up activity
                                            will be completed by year end 2022.
                                        </p>

                                        <div>
                                            Key contact -
                                            <span>Anna Paget</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12">
                                        <img
                                            src="assets/img/blog/Newsletter-Article5.png"
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="news-Article">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <p class="eyebrowText">
                                            OSDU on Microsoft
                                        </p>
                                        <h3>
                                            ExxonMobil’s OSDU PaaS solution on
                                            the new Microsoft Energy Data
                                            Services
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-7 col-md-12">
                                        <p>
                                            On September 20th, Microsoft
                                            announced the official launch of
                                            their new Microsoft Energy Data
                                            Services. ExxonMobil will use this
                                            new platform for our OSDU
                                            environment and initial set up is
                                            underway! To learn more about
                                            Microsoft’s new release, please see
                                            their blog post:
                                            <a
                                                href="https://cloudblogs.microsoft.com/industry-blog/energy/2022/09/20/announcing-microsoft-energy-data-services-enable-your-data-to-do-more-in-the-cloud/"
                                                >Microsoft Energy Data
                                                Services.</a
                                            >
                                        </p>

                                        <div>
                                            Key contact -
                                            <span>Maribel Chen</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12">
                                        <img
                                            src="assets/img/blog/Newsletter-Article6.jpeg"
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="news-Article">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12">
                                        <p class="eyebrowText">
                                            ExxonMobil leadership in OSDU
                                        </p>
                                        <h3>
                                            Heath Bland elected to the OSDU
                                            Management Committee
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-7 col-md-12">
                                        <p>
                                            In September, Heath Bland was
                                            elected to the OSDU Management
                                            Committee. He replaces Bryan Pate
                                            who was the previous OMC Chair and
                                            represented ExxonMobil for three
                                            years. Congratulations to both Heath
                                            and Bryan for demonstrating
                                            ExxonMobil’s leadership in the OSDU
                                            Forum<sup>TM</sup>!
                                        </p>
                                        <br />
                                        <a
                                            href="https://ishareteam7.na.xom.com/sites/UDAO/UDF/UDF_Site/index.html#/"
                                            >goto/UDF</a
                                        >

                                        <div>
                                            Key contact -
                                            <span>Daniel Bachmann</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-12">
                                        <img
                                            src="assets/img/blog/Newsletter-Article7.png"
                                            alt="image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="article-footer">
                        <div class="article-tags">
                            <span><i class="bx bx-purchase-tag"></i></span>

                            <a href="/community-of-practice">Community</a>,
                            <a href="/CoP-Roles">Membership</a>,
                            <a href="/benefits-CoP">Benefits</a>
                        </div>

                        <!-- <div class="article-share">
                            <ul class="social">
                                <li><span>Share:</span></li>
                                <li><a href="#" class="facebook" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="twitter" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="linkedin" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                                <li><a href="#" class="instagram" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                            </ul>
                        </div> -->
                    </div>

                    <!-- <div class="article-author">
                        <div class="author-profile-header"></div>
                        <div class="author-profile">
                            <div class="author-profile-title">
                                <img src="assets/img/user1.jpg" class="shadow-sm" alt="image">
                                <h4>Chris Orwig</h4>
                                <span class="d-block">Photographer, Author, Writer</span>
                                <p>Chris Orwig is a celebrated photographer, author, and writer who brings passion to everything he does. Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tempor.</p>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="tracer-post-navigation">
                        <div class="prev-link-wrapper">
                            <div class="info-prev-link-wrapper">
                                <a href="#">
                                    <span class="image-prev">
                                        <img src="assets/img/blog/img11.jpg" alt="image">
                                        <span class="post-nav-title">Prev</span>
                                    </span>

                                    <span class="prev-link-info-wrapper">
                                        <span class="prev-title">What Is The MLB Summer Slugger Program?</span>
                                        <span class="meta-wrapper">
                                            <span class="date-post">January 21, 2020</span>
                                        </span>
                                    </span>
                                </a>
                            </div>
                        </div>

                        <div class="next-link-wrapper">
                            <div class="info-next-link-wrapper">
                                <a href="#">
                                    <span class="next-link-info-wrapper">
                                        <span class="next-title">28 Student-Centered Instructional Strategies</span>
                                        <span class="meta-wrapper">
                                            <span class="date-post">January 19, 2020</span>
                                        </span>
                                    </span>

                                    <span class="image-next">
                                        <img src="assets/img/blog/img12.jpg" alt="image">
                                        <span class="post-nav-title">Next</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="comments-area">
                        <h3 class="comments-title">2 Comments:</h3>

                        <ol class="comment-list">
                            <li class="comment">
                                <article class="comment-body">
                                    <footer class="comment-meta">
                                        <div class="comment-author vcard">
                                            <img src="assets/img/user1.jpg" class="avatar" alt="image">
                                            <b class="fn">John Jones</b>
                                            <span class="says">says:</span>
                                        </div>

                                        <div class="comment-metadata">
                                            <a href="#">
                                                <span>April 24, 2019 at 10:59 am</span>
                                            </a>
                                        </div>
                                    </footer>

                                    <div class="comment-content">
                                        <p>Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen.</p>
                                    </div>

                                    <div class="reply">
                                        <a href="#" class="comment-reply-link">Reply</a>
                                    </div>
                                </article>

                                <ol class="children">
                                    <li class="comment">
                                        <article class="comment-body">
                                            <footer class="comment-meta">
                                                <div class="comment-author vcard">
                                                    <img src="assets/img/user2.jpg" class="avatar" alt="image">
                                                    <b class="fn">Steven Smith</b>
                                                    <span class="says">says:</span>
                                                </div>
    
                                                <div class="comment-metadata">
                                                    <a href="#">
                                                        <span>April 24, 2019 at 10:59 am</span>
                                                    </a>
                                                </div>
                                            </footer>
    
                                            <div class="comment-content">
                                                <p>Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen.</p>
                                            </div>
    
                                            <div class="reply">
                                                <a href="#" class="comment-reply-link">Reply</a>
                                            </div>
                                        </article>

                                        <ol class="children">
                                            <li class="comment">
                                                <article class="comment-body">
                                                    <footer class="comment-meta">
                                                        <div class="comment-author vcard">
                                                            <img src="assets/img/user3.jpg" class="avatar" alt="image">
                                                            <b class="fn">Sarah Taylor</b>
                                                            <span class="says">says:</span>
                                                        </div>
            
                                                        <div class="comment-metadata">
                                                            <a href="#">
                                                                <span>April 24, 2019 at 10:59 am</span>
                                                            </a>
                                                        </div>
                                                    </footer>
            
                                                    <div class="comment-content">
                                                        <p>Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen.</p>
                                                    </div>
            
                                                    <div class="reply">
                                                        <a href="#" class="comment-reply-link">Reply</a>
                                                    </div>
                                                </article>
                                            </li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>

                            <li class="comment">
                                <article class="comment-body">
                                    <footer class="comment-meta">
                                        <div class="comment-author vcard">
                                            <img src="assets/img/user4.jpg" class="avatar" alt="image">
                                            <b class="fn">John Doe</b>
                                            <span class="says">says:</span>
                                        </div>

                                        <div class="comment-metadata">
                                            <a href="#">
                                                <span>April 24, 2019 at 10:59 am</span>
                                            </a>
                                        </div>
                                    </footer>

                                    <div class="comment-content">
                                        <p>Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen.</p>
                                    </div>

                                    <div class="reply">
                                        <a href="#" class="comment-reply-link">Reply</a>
                                    </div>
                                </article>

                                <ol class="children">
                                    <li class="comment">
                                        <article class="comment-body">
                                            <footer class="comment-meta">
                                                <div class="comment-author vcard">
                                                    <img src="assets/img/user1.jpg" class="avatar" alt="image">
                                                    <b class="fn">James Anderson</b>
                                                    <span class="says">says:</span>
                                                </div>
    
                                                <div class="comment-metadata">
                                                    <a href="#">
                                                        <span>April 24, 2019 at 10:59 am</span>
                                                    </a>
                                                </div>
                                            </footer>
    
                                            <div class="comment-content">
                                                <p>Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen.</p>
                                            </div>
    
                                            <div class="reply">
                                                <a href="#" class="comment-reply-link">Reply</a>
                                            </div>
                                        </article>
                                    </li>
                                </ol>
                            </li>
                        </ol>

                        <div class="comment-respond">
                            <h3 class="comment-reply-title">Leave a Reply</h3>

                            <form class="comment-form">
                                <p class="comment-notes">
                                    <span id="email-notes">Your email address will not be published.</span>
                                    Required fields are marked 
                                    <span class="required">*</span>
                                </p>
                                <p class="comment-form-author">
                                    <label>Name <span class="required">*</span></label>
                                    <input type="text" id="author" placeholder="Your Name*" name="author" required="required">
                                </p>
                                <p class="comment-form-email">
                                    <label>Email <span class="required">*</span></label>
                                    <input type="email" id="email" placeholder="Your Email*" name="email" required="required">
                                </p>
                                <p class="comment-form-url">
                                    <label>Website</label>
                                    <input type="url" id="url" placeholder="Website" name="url">
                                </p>
                                <p class="comment-form-comment">
                                    <label>Comment</label>
                                    <textarea name="comment" id="comment" cols="45" placeholder="Your Comment..." rows="5" maxlength="65525" required="required"></textarea>
                                </p>
                                <p class="comment-form-cookies-consent">
                                    <input type="checkbox" value="yes" name="wp-comment-cookies-consent" id="wp-comment-cookies-consent">
                                    <label for="wp-comment-cookies-consent">Save my name, email, and website in this browser for the next time I comment.</label>
                                </p>
                                <p class="form-submit">
                                    <input type="submit" name="submit" id="submit" class="submit" value="Post A Comment">
                                </p>
                            </form>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <aside class="widget-area">
                    <!-- <section class="widget widget_search">
                        <h3 class="widget-title">Search</h3>

                        <form class="search-form">
                            <label>
                                <span class="screen-reader-text">Search for:</span>
                                <input type="search" class="search-field" placeholder="Search...">
                            </label>
                            <button type="submit"><i class="bx bx-search-alt"></i></button>
                        </form>
                    </section> -->

                    <section class="widget widget_tracer_posts_thumb">
                        <h3 class="widget-title">Popular Posts</h3>

                        <article
                            class="item"
                            *ngIf="this.pageData != 'what-is-CoP'"
                        >
                            <a href="/what-is-CoP" class="thumb">
                                <span
                                    class="fullimage cover bg1"
                                    role="img"
                                ></span>
                            </a>
                            <div class="info">
                                <!-- <span>June 10, 2020</span> -->
                                <h4 class="title usmall">
                                    <a href="/what-is-CoP"
                                        >What is Community of Practice?</a
                                    >
                                </h4>
                            </div>

                            <div class="clear"></div>
                        </article>

                        <article
                            class="item"
                            *ngIf="this.pageData != 'benefits-CoP'"
                        >
                            <a href="/benefits-CoP" class="thumb">
                                <span
                                    class="fullimage cover bg2"
                                    role="img"
                                ></span>
                            </a>
                            <div class="info">
                                <!-- <span>June 21, 2020</span> -->
                                <h4 class="title usmall">
                                    <a href="/benefits-CoP"
                                        >Benefits of Community of Practice</a
                                    >
                                </h4>
                            </div>

                            <div class="clear"></div>
                        </article>

                        <article
                            class="item"
                            *ngIf="this.pageData != 'CoP-Roles'"
                        >
                            <a href="/CoP-Roles" class="thumb">
                                <span
                                    class="fullimage cover bg3"
                                    role="img"
                                ></span>
                            </a>
                            <div class="info">
                                <!-- <span>June 30, 2020</span> -->
                                <h4 class="title usmall">
                                    <a href="/CoP-Roles"
                                        >Community of Practice Roles &
                                        Responsibilities</a
                                    >
                                </h4>
                            </div>

                            <div class="clear"></div>
                        </article>
                    </section>

                    <section class="widget widget_categories">
                        <h3 class="widget-title">Categories</h3>

                        <ul>
                            <li>
                                <a href="/community-of-practice">Community </a>
                            </li>
                            <li><a href="/CoP-Roles">Membership </a></li>
                            <li><a href="/benefits-CoP">Benefits </a></li>
                        </ul>
                    </section>

                    <section class="widget widget_tag_cloud">
                        <h3 class="widget-title">Popular Tags</h3>

                        <div class="tagcloud">
                            <a href="/community-of-practice"
                                >Community
                                <span class="tag-link-count"> (3)</span></a
                            >
                            <a
                                href="/CoP-Roles"
                                *ngIf="this.pageData === 'CoP-Roles'"
                                >Membership
                                <span class="tag-link-count"> (1)</span></a
                            >
                            <a
                                href="/benefits-CoP"
                                *ngIf="this.pageData === 'benefits-CoP'"
                                >Benefits
                                <span class="tag-link-count"> (1)</span></a
                            >
                        </div>
                    </section>
                </aside>
            </div>
        </div>
    </div>
</section>
